// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OO39F","textarea":"styles_textarea__u0GpR"};